var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgLeftArrow(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M11.7254 2.23501C11.3604 1.92166 10.772 1.92166 10.4071 2.23501L4.21785 7.54916C3.92738 7.79856 3.92738 8.20144 4.21785 8.45084L10.4071 13.765C10.772 14.0783 11.3604 14.0783 11.7254 13.765C12.0903 13.4516 12.0903 12.9464 11.7254 12.6331L6.33306 7.9968L11.7328 3.36051C12.0903 3.05356 12.0903 2.54197 11.7254 2.23501Z",
    fill: "#E1417F"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLeftArrow);
export default __webpack_public_path__ + "static/media/left-arrow.0c2d55f2.svg";
export { ForwardRef as ReactComponent };